// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xBbZ","icon":"styles_icon__3H-oi"};